(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/oddset-utils/assets/javascripts/oddset-utils.js') >= 0) return;  svs.modules.push('/components/sport/oddset-utils/assets/javascripts/oddset-utils.js'); 
'use strict';

(function(svs, _) {

  svs.oddset = svs.oddset || {};
  svs.oddset.utils = svs.oddset.utils || {};

  svs.oddset.utils.formatTime = function(regTime) {
    if (window.moment && regTime) {
      var dayPrefix = '';
      var diff = Math.floor(
        moment(regTime).diff(moment().startOf('day'), 'days', true)
      );
      switch (diff) {
        case -1:
          dayPrefix = 'Igår,';
          break;
        case 0:
          dayPrefix = 'Idag,';
          break;
        case 1:
          dayPrefix = 'Imorgon,';
          break;
        default:
      }

      if (dayPrefix !== '') {
        dayPrefix = dayPrefix + ' ' + moment(regTime).format('HH:mm');

        return dayPrefix;
      }
      dayPrefix = moment(regTime).format('dddd D/M, HH:mm');
      return dayPrefix.charAt(0).toUpperCase() + dayPrefix.slice(1);
    }
    return regTime;
  };

  svs.oddset.utils.result = function(match) {
    var result;
    result = _.findWhere(match.result, {
      type: svs.oddset.CURRENT_RESULT_PRIORITED
    });
    if (!result) {
      result = _.findWhere(match.result, { type: svs.oddset.CURRENT_RESULT });
      if (!result) {
        result = _.findWhere(match.result, {
          type: svs.oddset.PENALTIES_RESULT
        });
        if (!result) {
          result = _.findWhere(match.result, {
            type: svs.oddset.EXTRATIME2_RESULT
          });
          if (!result) {
            result = _.findWhere(match.result, {
              type: svs.oddset.EXTRATIME1_RESULT
            });
            if (!result) {
              result = _.findWhere(match.result, {
                type: svs.oddset.EXTRATIME_RESULT
              });
              if (!result) {
                result = _.findWhere(match.result, {
                  type: svs.oddset.FULLTIME_RESULT
                });
              }
            }
          }
        }
      }
    }
    if (!result && typeof match.result === 'object') {
      result = match.result;
    }
    return result;
  };

  svs.oddset.utils.formatDayOnly = function(regTime) {
    if (!regTime) return regTime;

    var d = svs.oddset.utils.formatTime(regTime);
    return d.split(' ')[0];
  };

  svs.oddset.utils.eventDescription = function(
    event,
    withdetails,
    withextrainfo
  ) {
    var description;

    if (!(event instanceof Backbone.Model)) {
      if (_.isObject(event)) {
        event = new svs.sport.oddsetbase.models.EventBase(event);
      } else {
        return '';
      }
    }

    description = event.get('description');

    if (withdetails && withextrainfo && event.get('extraInfo') !== '') {
      description += ' - ' + event.get('extraInfo');
    }

    return description;
  };

  svs.oddset.utils.isMatchStarted = function(match) {
    var matchStatusId;

    if (
      (match && typeof match.statusId !== 'undefined') ||
      typeof match.status !== 'undefined'
    ) {
      matchStatusId = match.statusId || match.status;
    } else if (
      match &&
      (typeof match.match.statusId !== 'undefined' ||
        typeof match.match.status !== 'undefined')
    ) {
      matchStatusId = match.match.statusId || match.match.status;
    }

    return (
      matchStatusId > 0 &&
      matchStatusId !== svs.statistics.constants.MATCH_STATUS_POSTPONED &&
      matchStatusId !== svs.statistics.constants.MATCH_STATUS_START_DELAYED &&
      matchStatusId !== svs.statistics.constants.MATCH_STATUS_CANCELLED
    );
  };

  svs.oddset.utils.isEmpty = function(arg) {
    return (
      arg === '' ||
      arg === null ||
      arg === undefined ||
      arg === 'null' ||
      arg === 'undefined'
    );
  };

  if (svs.isServer) {
    module.exports = svs.oddset.utils;
  }
})(svs, svs.isServer ? require('underscore') : _);

 })(window);